import * as Types from '../../types/gql';

export type WithdrawSoftBlockVariables = Types.Exact<{ [key: string]: never }>;

export type WithdrawSoftBlock = {
  currentUser?: Types.Maybe<{
    clearingWithdrawSoftBlock?: Types.Maybe<{ expirationDate?: Types.Maybe<string> }>;
  }>;
};
